module.exports = __webpack_public_path__ + "static/media/noun-video-tutorial-4691955.803452b2.svg";